export const getApiBaseUrl = (): string => {
  if (process.env.REACT_APP_GATEWAY_REST_API_URL)
    return process.env.REACT_APP_GATEWAY_REST_API_URL;
  else throw new Error('Gateway Base Url NotFound In Env');
};
export const getApiBaseGatewayUrl = (): string => {
  if (process.env.REACT_APP_GATEWAY) return process.env.REACT_APP_GATEWAY;
  else throw new Error('Gateway Base Url NotFound In Env');
};

export const getVimeoVideoBaseUrl = (): string => {
  if (process.env.REACT_APP_VIMEO_VIDEO_BASE_URL)
    return process.env.REACT_APP_VIMEO_VIDEO_BASE_URL;
  else throw new Error('Vimeo Video Base Url NotFound In Env');
};

export const getVimeoAPI = (): string => {
  if (process.env.REACT_APP_VIMEO_API) return process.env.REACT_APP_VIMEO_API;
  else throw new Error('Vimeo API NotFound In Env');
};

export const getGoogleMapsAPIKey = (): string => {
  if (process.env.REACT_APP_GOOGLE_MAPS_API_KEY)
    return process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
  else throw new Error('Google Maps API Key NotFound In Env');
};
